import { DataAttributeDefinitions } from 'scrivito'

import { pisaInvoiceDataClass } from './Pisa/pisaInvoiceDataClass'

const attributes: DataAttributeDefinitions = {}

export const Invoice = pisaInvoiceDataClass(attributes)
